import PropTypes from 'prop-types'
import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import Layout from './views'

const SpaHeader = ({ transparent = false }) => {
  const { template } = useTemplateContext()
  return (
    <Layout.Header 
      textColor='primary'
      backgroundColor={transparent ? undefined : "complementary"}
    >
      <CommonComponents.Wrapper height="80px">
        <Layout.Logo>
          {template.logo.src ? (
            <Layout.LogoImage src={template.logo.src} />
          ) : (
            <Layout.LogoText fontFamily={template.logo.fontFamily}>
              {template.logo.text}
            </Layout.LogoText>
          )}
        </Layout.Logo>
      </CommonComponents.Wrapper>
    </Layout.Header>
  )
}

SpaHeader.propTypes = {
  transparent: PropTypes.bool,
}

export default SpaHeader
